import { cn } from "@/lib/utils";
import { Info } from "lucide-react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useDataTableSettings } from "@/components/data-table/hooks/useDataTableSettings";

interface InMemoryTableStatusProps extends PropsWithChildren {
  className?: string;
}

export const InMemoryTableStatus = <TData extends { id: string }>({
  className,
  children,
}: InMemoryTableStatusProps) => {
  const { t } = useTranslation();
  const { table } = useDataTableSettings<TData>();
  const defaultClassName = "flex items-center gap-4 text-sm text-slate-600";

  return (
    <span
      className={cn(
        "flex gap-5 text-sm text-slate-600",
        defaultClassName,
        className,
      )}
    >
      {children}
      <span className="flex items-center gap-2 shrink-0">
        <Info className="w-4 h-4" />
        <span>{t("table.status", { count: table.getRowCount() })}</span>
      </span>
    </span>
  );
};
